export const isOptimizelyEnabled = () => {
  if (typeof window === "undefined") return false;

  if (typeof window.optimizely === "undefined") {
    window.optimizely = window.optimizely || [];
  }

  return typeof window.optimizely.get === "function";
};
